module.exports = __webpack_public_path__ + "img/br4.f6806b19.png";